import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Tag, Table, Spin } from "antd";
import Header from "../../Header/Header";
import SideBar from "../../SideBar/SideBar";
import Footer from "../../Footer/Footer";
import UserProfile from "../../commen/userinteface";
import {
  getTeamBasedOnUserId,
  getTeamApplicationsWithId,
  getAllApplications,
} from "../../HttpRequest/applyapplication";
import { dashBoardCount } from "../../HttpRequest/dashboard";
import "./teamdashboard.css";

const TeamUserDashboard = () => {
  const [profileData, setProfileData] = useState(UserProfile());
  const [loading, setLoading] = useState(true);
  const [assignedApplications, setAssignedApplications] = useState([]);
  const [metrics, setMetrics] = useState({
    totalAssigned: 0,
    underReview: 0,
    submittedToUni: 0,
    approvedOffers: 0,
  });

  useEffect(() => {
    const userId = sessionStorage.getItem("id") || localStorage.getItem("id");

    const fetchAssistantData = async () => {
      try {
        setLoading(true);

        // Fetch user dashboard counts if available
        if (userId) {
          try {
            const countRes = await dashBoardCount(userId);
            if (countRes && countRes.data) {
              setMetrics({
                totalAssigned:
                  countRes.data["application-requested"] ||
                  countRes.data["total"] ||
                  0,
                underReview:
                  countRes.data["application-submitted"] ||
                  countRes.data["pending"] ||
                  0,
                submittedToUni:
                  countRes.data["approve-and-assign"] ||
                  countRes.data["in-progress"] ||
                  0,
                approvedOffers: countRes.data["reject"] || 0,
              });
            }
          } catch (err) {
            console.log("Count fetch error:", err);
          }
        }

        // Fetch assigned team applications
        if (userId) {
          try {
            const teamRes = await getTeamBasedOnUserId(userId);
            if (
              teamRes &&
              teamRes.data &&
              teamRes.data.data &&
              teamRes.data.data.length > 0
            ) {
              const teamId = teamRes.data.data[0].id;
              const appsRes = await getTeamApplicationsWithId(teamId, 0, 10);
              if (appsRes && appsRes.data && appsRes.data.data) {
                setAssignedApplications(appsRes.data.data);
                setMetrics((prev) => ({
                  ...prev,
                  totalAssigned: appsRes.data.data.length || prev.totalAssigned,
                }));
              }
            } else {
              // Fallback to recent applications
              const allAppsRes = await getAllApplications(0, 10);
              if (allAppsRes && allAppsRes.data && allAppsRes.data.data) {
                setAssignedApplications(allAppsRes.data.data);
                setMetrics((prev) => ({
                  ...prev,
                  totalAssigned:
                    allAppsRes.data.data.length || prev.totalAssigned,
                }));
              }
            }
          } catch (err) {
            console.log("Team apps fetch error:", err);
            // Fallback to general applications
            try {
              const allAppsRes = await getAllApplications(0, 10);
              if (allAppsRes && allAppsRes.data && allAppsRes.data.data) {
                setAssignedApplications(allAppsRes.data.data);
              }
            } catch (fallbackErr) {
              console.log("Fallback apps error:", fallbackErr);
            }
          }
        }
      } catch (error) {
        console.error("Error loading assistant dashboard:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAssistantData();
  }, []);

  const assistantName =
    profileData?.firstName ||
    sessionStorage.getItem("name") ||
    sessionStorage.getItem("firstName") ||
    sessionStorage.getItem("userName") ||
    "Bablu";

  const getStatusColor = (status) => {
    if (!status) return "default";
    const s = status.toLowerCase();
    if (s.includes("approved") || s.includes("offer") || s.includes("visa"))
      return "success";
    if (s.includes("submit") || s.includes("assigned")) return "processing";
    if (s.includes("review") || s.includes("pending")) return "warning";
    if (s.includes("reject")) return "error";
    return "gold";
  };

  const tableColumns = [
    {
      title: "App ID / Student",
      dataIndex: "id",
      key: "id",
      render: (id, record) => (
        <div>
          <strong className="text-warning">#{id || "N/A"}</strong>
          <div className="text-white small font-weight-bold">
            {record.userName ||
              record.studentName ||
              record.user?.firstName ||
              "Student Applicant"}
          </div>
          <div className="text-muted small" style={{ fontSize: "11px" }}>
            {record.userEmail || record.user?.email || ""}
          </div>
        </div>
      ),
    },
    {
      title: "Target University",
      dataIndex: "university",
      key: "university",
      render: (uni, record) => (
        <div>
          <span className="text-white font-weight-bold">
            {uni || record.universityName || "University"}
          </span>
          <div className="text-muted small" style={{ fontSize: "12px" }}>
            <i className="fas fa-graduation-cap text-warning mr-1"></i>
            {record.course || record.courseName || "Undergraduate / Postgrad"}
          </div>
        </div>
      ),
    },
    {
      title: "Intake",
      dataIndex: "intake",
      key: "intake",
      render: (intake) => (
        <span className="ops-pill ops-pill-gold">
          <i className="fas fa-calendar-alt"></i> {intake || "Fall 2024 / Spring 2025"}
        </span>
      ),
    },
    {
      title: "Processing Status",
      dataIndex: "applicationStatus",
      key: "applicationStatus",
      render: (status) => (
        <Tag color={getStatusColor(status)} className="px-2 py-1 font-weight-bold">
          {status || "In Review"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Link
          to="/adminstudentview"
          className="btn btn-sm btn-outline-warning text-nowrap"
          style={{ borderRadius: "6px", fontSize: "12px" }}
        >
          <i className="fas fa-tasks mr-1"></i> Process Application
        </Link>
      ),
    },
  ];

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <SideBar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header mb-4">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <span className="ops-pill ops-pill-gold">
                      <i className="fas fa-headset mr-1"></i> Application Operations Desk
                    </span>
                  </div>
                  <h3 className="page-title text-white font-weight-bold mb-1">
                    Welcome, {assistantName}!
                  </h3>
                  <p className="text-muted small mb-0">
                    Review assigned student documentation, track university admissions, and update visa milestones.
                  </p>
                </div>
                <div className="col-md-4 text-md-end mt-3 mt-md-0">
                  <Link
                    to="/adminstudentview"
                    className="btn btn-warning font-weight-bold px-3 py-2 shadow-sm"
                    style={{ borderRadius: "8px", fontSize: "13px" }}
                  >
                    <i className="fas fa-clipboard-list mr-1"></i> View All Applications
                  </Link>
                </div>
              </div>
            </div>

            {/* Metrics Overview Cards */}
            <div className="row g-3 mb-4">
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card ops-metric-card w-100 mb-0 shadow-sm">
                  <div className="card-body p-3.5">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="text-muted small font-weight-bold text-uppercase d-block mb-1" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
                          Total Assigned
                        </span>
                        <h3 className="text-white font-weight-bold mb-0">
                          {metrics.totalAssigned || assignedApplications.length || "0"}
                        </h3>
                        <small className="text-warning" style={{ fontSize: "11px" }}>
                          Active student files
                        </small>
                      </div>
                      <div
                        className="ops-icon-box"
                        style={{ background: "rgba(212, 175, 55, 0.12)", color: "#D4AF37" }}
                      >
                        <i className="fas fa-folder-open fa-lg"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card ops-metric-card w-100 mb-0 shadow-sm">
                  <div className="card-body p-3.5">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="text-muted small font-weight-bold text-uppercase d-block mb-1" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
                          Document Review
                        </span>
                        <h3 className="text-warning font-weight-bold mb-0">
                          {metrics.underReview || "0"}
                        </h3>
                        <small className="text-muted" style={{ fontSize: "11px" }}>
                          SOP & transcripts pending
                        </small>
                      </div>
                      <div
                        className="ops-icon-box"
                        style={{ background: "rgba(255, 193, 7, 0.12)", color: "#ffc107" }}
                      >
                        <i className="fas fa-file-signature fa-lg"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card ops-metric-card w-100 mb-0 shadow-sm">
                  <div className="card-body p-3.5">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="text-muted small font-weight-bold text-uppercase d-block mb-1" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
                          Under Uni Review
                        </span>
                        <h3 className="text-info font-weight-bold mb-0">
                          {metrics.submittedToUni || "0"}
                        </h3>
                        <small className="text-muted" style={{ fontSize: "11px" }}>
                          Submitted to portals
                        </small>
                      </div>
                      <div
                        className="ops-icon-box"
                        style={{ background: "rgba(13, 202, 240, 0.12)", color: "#0dcaf0" }}
                      >
                        <i className="fas fa-university fa-lg"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card ops-metric-card w-100 mb-0 shadow-sm">
                  <div className="card-body p-3.5">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="text-muted small font-weight-bold text-uppercase d-block mb-1" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
                          Offers & Visas
                        </span>
                        <h3 className="text-success font-weight-bold mb-0">
                          {metrics.approvedOffers || "0"}
                        </h3>
                        <small className="text-success" style={{ fontSize: "11px" }}>
                          Admissions secured
                        </small>
                      </div>
                      <div
                        className="ops-icon-box"
                        style={{ background: "rgba(25, 135, 84, 0.12)", color: "#198754" }}
                      >
                        <i className="fas fa-award fa-lg"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Application Operations Pipeline Stepper Card */}
            <div className="card pipeline-container-card mb-4 shadow-sm">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                  <h5 className="text-white font-weight-bold mb-0 d-flex align-items-center gap-2">
                    <i className="fas fa-sliders-h text-warning"></i> 4-Stage Operational Processing Pipeline
                  </h5>
                  <span className="ops-pill ops-pill-gold">
                    <i className="fas fa-check-circle mr-1"></i> Standard Workflow
                  </span>
                </div>

                <div className="pipeline-grid">
                  <div className="pipeline-step-box">
                    <div className="pipeline-step-badge step-1">1</div>
                    <h6 className="text-warning font-weight-bold mb-1" style={{ fontSize: "13px" }}>Document Review</h6>
                    <p className="text-muted small mb-0" style={{ fontSize: "11px" }}>Verify SOP, Transcripts & IELTS</p>
                  </div>

                  <div className="pipeline-step-box">
                    <div className="pipeline-step-badge step-2">2</div>
                    <h6 className="text-info font-weight-bold mb-1" style={{ fontSize: "13px" }}>Uni Submission</h6>
                    <p className="text-muted small mb-0" style={{ fontSize: "11px" }}>Portal upload & fee clearance</p>
                  </div>

                  <div className="pipeline-step-box">
                    <div className="pipeline-step-badge step-3">3</div>
                    <h6 className="text-primary font-weight-bold mb-1" style={{ fontSize: "13px" }}>Offer & I-20 / CAS</h6>
                    <p className="text-muted small mb-0" style={{ fontSize: "11px" }}>Accept offer & finance proofs</p>
                  </div>

                  <div className="pipeline-step-box">
                    <div className="pipeline-step-badge step-4">4</div>
                    <h6 className="text-success font-weight-bold mb-1" style={{ fontSize: "13px" }}>Visa Filing</h6>
                    <p className="text-muted small mb-0" style={{ fontSize: "11px" }}>VFS appointment & Visa grant</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Assigned Applications Queue Table Card */}
            <div className="card ops-queue-card mb-4 shadow-sm">
              <div className="ops-queue-header d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="card-title text-white font-weight-bold mb-1">
                    <i className="fas fa-user-graduate text-warning mr-2"></i> Assigned Student Applications Queue
                  </h5>
                  <p className="text-muted small mb-0">
                    Student applications requiring your review, document clearance, and submission
                  </p>
                </div>
                <Link
                  to="/adminstudentview"
                  className="btn btn-sm btn-outline-warning"
                  style={{ borderRadius: "6px" }}
                >
                  <i className="fas fa-external-link-alt mr-1"></i> Full Applications Table
                </Link>
              </div>

              <div className="card-body p-0">
                {loading ? (
                  <div className="text-center py-5">
                    <Spin size="large" />
                    <p className="text-muted small mt-2">Loading assigned student applications...</p>
                  </div>
                ) : assignedApplications.length > 0 ? (
                  <div className="table-responsive p-3">
                    <Table
                      columns={tableColumns}
                      dataSource={assignedApplications.map((app, i) => ({
                        ...app,
                        key: app.id || i,
                      }))}
                      pagination={{ pageSize: 6 }}
                      className="table-dark-custom"
                    />
                  </div>
                ) : (
                  <div className="ops-empty-state">
                    <div className="ops-empty-icon">
                      <i className="fas fa-clipboard-check"></i>
                    </div>
                    <h5 className="text-white font-weight-bold mb-1">No Pending Applications in Queue</h5>
                    <p className="text-muted small mb-3" style={{ maxWidth: "480px", margin: "0 auto" }}>
                      All assigned student applications have been processed, or new student leads have not been assigned yet.
                    </p>
                    <Link to="/normalsearch" className="btn btn-warning font-weight-bold px-4 py-2 mt-2" style={{ borderRadius: "8px", fontSize: "13px" }}>
                      <i className="fas fa-search mr-1"></i> Search University Programs
                    </Link>
                  </div>
                )}
              </div>
            </div>

            {/* Quick Operational Tools */}
            <div className="row g-3 mb-4">
              <div className="col-md-4 d-flex">
                <div className="card ops-tool-card w-100 shadow-sm">
                  <div className="d-flex align-items-center gap-3">
                    <div className="ops-icon-box" style={{ background: "rgba(212, 175, 55, 0.12)", color: "#D4AF37" }}>
                      <i className="fas fa-search fa-lg"></i>
                    </div>
                    <div>
                      <h6 className="text-white font-weight-bold mb-0">Course & Program Finder</h6>
                      <p className="text-muted small mb-1" style={{ fontSize: "11px" }}>Search universities and entry requirements</p>
                      <Link to="/normalsearch" className="text-warning small font-weight-bold text-decoration-none">
                        Open Program Search <i className="fas fa-arrow-right ml-1"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 d-flex">
                <div className="card ops-tool-card w-100 shadow-sm">
                  <div className="d-flex align-items-center gap-3">
                    <div className="ops-icon-box" style={{ background: "rgba(13, 202, 240, 0.12)", color: "#0dcaf0" }}>
                      <i className="fas fa-clipboard-list fa-lg"></i>
                    </div>
                    <div>
                      <h6 className="text-white font-weight-bold mb-0">All Applications Hub</h6>
                      <p className="text-muted small mb-1" style={{ fontSize: "11px" }}>Filter by intake, country & status</p>
                      <Link to="/adminstudentview" className="text-info small font-weight-bold text-decoration-none">
                        Open Applications Hub <i className="fas fa-arrow-right ml-1"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 d-flex">
                <div className="card ops-tool-card w-100 shadow-sm">
                  <div className="d-flex align-items-center gap-3">
                    <div className="ops-icon-box" style={{ background: "rgba(220, 53, 69, 0.12)", color: "#dc3545" }}>
                      <i className="fas fa-headset fa-lg"></i>
                    </div>
                    <div>
                      <h6 className="text-white font-weight-bold mb-0">Support & Help Desk</h6>
                      <p className="text-muted small mb-1" style={{ fontSize: "11px" }}>Handle student queries & inquiries</p>
                      <Link to="/issues" className="text-danger small font-weight-bold text-decoration-none">
                        View Help Desk <i className="fas fa-arrow-right ml-1"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};

export default TeamUserDashboard;
